var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1253 12.8386L15.6237 14.8322",
    stroke: "#210B2B",
    strokeWidth: 1.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4989 6.08279H7.49951",
    stroke: "#210B2B",
    strokeWidth: 1.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99936 1.0831H14.999C16.3797 1.0831 17.4989 2.20232 17.4989 3.58294V8.58263C17.4989 11.3439 15.2605 13.5823 12.4992 13.5823V13.5823C9.73795 13.5823 7.49951 11.3439 7.49951 8.58263V3.58294C7.49951 2.20232 8.61873 1.0831 9.99936 1.0831Z",
    stroke: "#210B2B",
    strokeWidth: 1.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87593 12.8386L8.94724 16.5534",
    stroke: "#210B2B",
    strokeWidth: 1.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7492 17.4123C11.9866 17.7621 10.1573 17.3906 8.67079 16.3809C8.42125 16.2148 8.11601 16.1546 7.82209 16.2134L4.26481 16.9246C2.51179 17.275 1.24989 18.8142 1.25 20.6019V21.0818",
    stroke: "#210B2B",
    strokeWidth: 1.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49947 16.2778V21.0818",
    stroke: "#210B2B",
    strokeWidth: 1.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.49939,
    cy: 22.9567,
    r: 1.87488,
    stroke: "#210B2B",
    strokeWidth: 1.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7866 17.9786L19.9987 18.194L20.218 17.9622C20.5901 17.5652 21.1083 17.3376 21.6523 17.3322C22.1964 17.3267 22.7191 17.5439 23.099 17.9333L23.1436 17.9786C23.9501 18.8074 23.9501 20.1276 23.1436 20.9564L20.9509 23.1829C20.6998 23.438 20.3567 23.5817 19.9987 23.5817C19.6407 23.5817 19.2977 23.438 19.0466 23.1829L16.8539 20.9565C16.0474 20.1277 16.0474 18.8074 16.8539 17.9786V17.9786C17.2407 17.5857 17.7689 17.3644 18.3203 17.3644C18.8716 17.3644 19.3998 17.5857 19.7866 17.9786Z",
    stroke: "#210B2B",
    strokeWidth: 1.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperts);
export default __webpack_public_path__ + "static/media/Experts.9552431424c3e638e59905a6325be97e.svg";
export { ForwardRef as ReactComponent };